import template from './ticketTable.html';
import { TicketTableController } from './ticketTable.controller';

export const ticketTableComponent = {
  restrict: 'E',
  template,
  controller: TicketTableController,
  controllerAs: 'vm',
  bindings: {
    ticketType: '@',
    closed: '<',
    product: '<',
    filterOptions: '<',
    page: '<',
    hide: '&',
  },
};
